// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Lato", sans-serif;
  text-align: center;
  padding-top: 60px;
}

h2 {
  font-size: 50px;
  margin-bottom: 0px;
  font-weight: 100;
}

p {
  font-size: 18px;
}

.transition {
  transition: 0.3s cubic-bezier(0.3, 0, 0, 1.3);
}

.three .transition {
  transition: 0.7s cubic-bezier(0.3, 0, 0, 1.3);
}

.five .transition {
  transition: 0.5s cubic-bezier(0.3, 0, 0, 1.3);
}

/* --------- ONE --------- */
.one {
  list-style: none;
  padding: 0;
  margin: 100px 0;
}

.one > li {
  background: #FFFFFF;
  border: 1px solid rgba(150, 150, 150, 0.29);
  box-shadow: 0px 0px 18px 0px rgba(103, 85, 85, 0.39);
  width: 250px;
  height: 312px;
  display: inline-block;
  margin: 0 20px;
  text-align: center;
}

.one > li img {
  margin-top: 32px;
}

.one > li:hover img {
  margin-top: 30px;
}

.one > li:hover {
  box-shadow: 0px 0px 5px 0px rgba(103, 85, 85, 0.25);
}

.one > li:hover span {
  border-radius: 0;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  bottom: -400px;
}

.one > li:hover h3 {
  color: rgb(255, 255, 255);
  margin-top: 25px;
}

.one > li .wrapper {
  overflow: hidden;
  position: absolute;
  width: 250px;
  height: 310px;
}

.one > li span {
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  height: 390px;
  width: 500px;
  background: #589BBE;
  display: block;
  position: absolute;
  bottom: -260px;
  left: -125px;
}

.one > li span img {
  margin-top: 10px;
  width: 50px;
}

.one > li span:hover {
  background: #589BBE;
}

.one > li h3 {
  margin-top: 40px;
  color: rgb(255, 255, 255);
}

.one > li h3 em {
  display: block;
  font-style: normal;
  text-transform: uppercase;
  font-weight: 300;
  font-size: 12px;
  margin-top: 5px;
}

.one .social {
  list-style: none;
  text-align: center;
  margin: 10px 0 0 0;
  padding: 10px;
}

.one .social li {
  opacity: 0;
  display: inline-block;
  padding: 5px;
}

.one > li:hover .social li {
  opacity: 0.5;
}

.one .social li a {
  cursor: pointer;
  display: block;
}

.one .social li a:hover {
  opacity: 0.5;
}

.one .social li img {
  width: 24px;
}

.image-team {
  border-radius: 60px;
  width: 110px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/team-presentation/team-presentation.component.scss"],"names":[],"mappings":"AAMA;EACE,+BAAA;EACA,kBAAA;EACA,iBAAA;AALF;;AAQA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AALF;;AAQA;EACE,eAAA;AALF;;AAQA;EACE,6CAAA;AALF;;AAQA;EACE,6CAAA;AALF;;AAQA;EACE,6CAAA;AALF;;AAQA,4BAAA;AAGA;EACE,gBAAA;EACA,UAAA;EACA,eAAA;AAPF;;AAUA;EACE,mBAAA;EACA,2CAAA;EAEA,oDAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;AAPF;;AAUA;EACE,gBAAA;AAPF;;AAUA;EACE,gBAAA;AAPF;;AAUA;EAEE,mDAAA;AAPF;;AAUA;EACE,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,cAAA;AAPF;;AAUA;EACE,yBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AAPF;;AAUA;EACE,kBAAA;EACA,0BAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAzFW;EA0FX,cAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AAPF;;AAUA;EACE,gBAAA;EACA,WAAA;AAPF;;AAUA;EACE,mBAtGW;AA+Fb;;AAUA;EACE,gBAAA;EACA,yBAAA;AAPF;;AAUA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AAPF;;AAUA;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AAPF;;AAUA;EACE,UAAA;EACA,qBAAA;EACA,YAAA;AAPF;;AAUA;EACE,YAAA;AAPF;;AAUA;EACE,eAAA;EACA,cAAA;AAPF;;AAUA;EACE,YAAA;AAPF;;AAUA;EACE,WAAA;AAPF;;AAUA;EAGE,mBAAA;EACA,YAAA;AAPF","sourcesContent":["//@import url('https://fonts.googleapis.com/css?family=Lato:400,700');\r\n//@import url('https://fonts.googleapis.com/css?family=Dosis:400,700');\r\n//@import url('https://fonts.googleapis.com/css?family=Open+Sans:400,700');\r\n\r\n$color-back: #589BBE;\r\n\r\nbody {\r\n  font-family: 'Lato', sans-serif;\r\n  text-align: center;\r\n  padding-top: 60px;\r\n}\r\n\r\nh2 {\r\n  font-size: 50px;\r\n  margin-bottom: 0px;\r\n  font-weight: 100;\r\n}\r\n\r\np {\r\n  font-size: 18px;\r\n}\r\n\r\n.transition {\r\n  transition: .3s cubic-bezier(.3, 0, 0, 1.3)\r\n}\r\n\r\n.three .transition {\r\n  transition: .7s cubic-bezier(.3, 0, 0, 1.3)\r\n}\r\n\r\n.five .transition {\r\n  transition: .5s cubic-bezier(.3, 0, 0, 1.3)\r\n}\r\n\r\n/* --------- ONE --------- */\r\n\r\n\r\n.one {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 100px 0;\r\n}\r\n\r\n.one > li {\r\n  background: #FFFFFF;\r\n  border: 1px solid rgba(150, 150, 150, 0.29);\r\n  -moz-box-shadow: 0px 0px 18px 0px rgba(103, 85, 85, 0.39);\r\n  box-shadow: 0px 0px 18px 0px rgba(103, 85, 85, 0.39);\r\n  width: 250px;\r\n  height: 312px;\r\n  display: inline-block;\r\n  margin: 0 20px;\r\n  text-align: center;\r\n}\r\n\r\n.one > li img {\r\n  margin-top: 32px;\r\n}\r\n\r\n.one > li:hover img {\r\n  margin-top: 30px;\r\n}\r\n\r\n.one > li:hover {\r\n  -moz-box-shadow: 0px 0px 5px 0px rgba(103, 85, 85, 0.25);\r\n  box-shadow: 0px 0px 5px 0px rgba(103, 85, 85, 0.25);\r\n}\r\n\r\n.one > li:hover span {\r\n  border-radius: 0;\r\n  -webkit-border-radius: 0;\r\n  -moz-border-radius: 0;\r\n  bottom: -400px;\r\n}\r\n\r\n.one > li:hover h3 {\r\n  color: rgba(255, 255, 255, 1);\r\n  margin-top: 25px;\r\n}\r\n\r\n.one > li .wrapper {\r\n  overflow: hidden;\r\n  position: absolute;\r\n  width: 250px;\r\n  height: 310px;\r\n}\r\n\r\n.one > li span {\r\n  border-radius: 50%;\r\n  -webkit-border-radius: 50%;\r\n  -moz-border-radius: 50%;\r\n  height: 390px;\r\n  width: 500px;\r\n  background: $color-back;\r\n  display: block;\r\n  position: absolute;\r\n  bottom: -260px;\r\n  left: -125px;\r\n}\r\n\r\n.one > li span img {\r\n  margin-top: 10px;\r\n  width: 50px;\r\n}\r\n\r\n.one > li span:hover {\r\n  background: $color-back;\r\n}\r\n\r\n.one > li h3 {\r\n  margin-top: 40px;\r\n  color: rgba(255, 255, 255, 1);\r\n}\r\n\r\n.one > li h3 em {\r\n  display: block;\r\n  font-style: normal;\r\n  text-transform: uppercase;\r\n  font-weight: 300;\r\n  font-size: 12px;\r\n  margin-top: 5px;\r\n}\r\n\r\n.one .social {\r\n  list-style: none;\r\n  text-align: center;\r\n  margin: 10px 0 0 0;\r\n  padding: 10px;\r\n}\r\n\r\n.one .social li {\r\n  opacity: 0;\r\n  display: inline-block;\r\n  padding: 5px;\r\n}\r\n\r\n.one > li:hover .social li {\r\n  opacity: 0.5;\r\n}\r\n\r\n.one .social li a {\r\n  cursor: pointer;\r\n  display: block;\r\n}\r\n\r\n.one .social li a:hover {\r\n  opacity: 0.5;\r\n}\r\n\r\n.one .social li img {\r\n  width: 24px;\r\n}\r\n\r\n.image-team {\r\n  -webkit-border-radius: 60px;\r\n  -moz-border-radius: 60px;\r\n  border-radius: 60px;\r\n  width: 110px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
